import { useEffect, useState } from 'react'
import { isWeb } from '@/components/WebWrapper'

/**
 * Hook to detect window resize events (web only)
 * Returns a key that increments on each resize, useful for triggering re-measurements
 * @returns A number that increments on window resize (debounced by 100ms)
 */
export const useWindowResizeKey = () => {
  const [resizeKey, setResizeKey] = useState(0)

  useEffect(() => {
    if (!isWeb) return

    let timeoutId: ReturnType<typeof setTimeout>
    const handleResize = () => {
      clearTimeout(timeoutId)
      timeoutId = setTimeout(() => {
        setResizeKey((k) => k + 1)
      }, 100)
    }

    window.addEventListener('resize', handleResize)
    return () => {
      clearTimeout(timeoutId)
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return resizeKey
}
